import GlobalStyle from './global-styles';
import theme, { transitions } from './theme';

export default theme;
export { GlobalStyle, transitions };
